angular.module('wbDashboard').controller('FormulaDetailControllerAurea',
       ['$scope', '$uibModal', '$q', 'FormulaService', 'User', 'Message',
function ($scope, $uibModal, $q, FormulaService, User, Message) {

    $scope.$watch(function() { return FormulaService.user.getFormulas($scope.$stateParams.formulaSlug); }, function(formula) {
        if (formula) {
            $scope.formula = formula;
        } else {
            //check if formulas hae indeed been loaded, if so, leave if it still doesn't exist
            if (FormulaService.user.getFormulas() != null) {
                $scope.$state.go('base.formulas', {}, {location: "replace"});
            }
        }
    });

    $scope.deleteFormulaModal = function() {
        var modalInstance = $uibModal.open({
            templateUrl: 'modal-confirm-formula-delete.tpl.html',
            scope:$scope,
            size: 'md',
            windowClass:'confirm-modal modal-confirm-formula-delete center'
        });

        modalInstance.result.then(function () {
            $scope.pageData.sending = true;
            return FormulaService.user.deleteFormula($scope.formula.slug).then(function(response) {
                // Necessary to update?
                // User.retrieveOverview(true);
                // User.retrieveAllMilestones(true);

                return $q.all([FormulaService.user.retrieveFormulas(true), FormulaService.retrieveFormulas(true)]);
            }).then(function(response) {
                Message.set({
                    text: `Successfully deleted ${$scope.formula.title} Formula`,
                    type: "warning"
                });
                $scope.$state.go('base.formulas');
            }).catch(function() {
                Message.set({
                    text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                    type: "danger"
                });
            }).finally(function() {
                $scope.pageData.sending = false;
            });

        }).catch(angular.noop); //dismissed/cancelled

    };


}]);
